import { BorderShapeId, LegsShapeId } from '@core/constants/Shape';

export const allLegs: LegsShapeId[] = [
    LegsShapeId.LegsMikado,
    LegsShapeId.LegsCross,
    LegsShapeId.LegsHairPin,
    LegsShapeId.LegsTrapezeInverted,
    LegsShapeId.LegsMonastery,
    LegsShapeId.LegsRightCrossPiece,
    LegsShapeId.LegsScandinavian,
    LegsShapeId.LegsSquareCrossPiece,
    LegsShapeId.LegsTrapeze,
    LegsShapeId.LegsTrestleCross,
    LegsShapeId.LegsUShaped,
    LegsShapeId.LegsRoundLegs,
    LegsShapeId.LegsSquare,
    LegsShapeId.LegsTrapezeCentral,
    LegsShapeId.LegsVShaped,
    LegsShapeId.LegsVShapedCentral,
    LegsShapeId.LegsUShapedStrengthened,
    LegsShapeId.LegsAdventurer,
    LegsShapeId.LegsClassic,
    LegsShapeId.LegsGreedy,
    LegsShapeId.LegsHarmonious,
    LegsShapeId.LegsMalicious,
    LegsShapeId.LegsRider,
    LegsShapeId.LegsOther,
];

export const allBorders: BorderShapeId[] = [
    BorderShapeId.SquareStraightEdge,
    BorderShapeId.LiveEdge,
    BorderShapeId.StraightEdgeChamfer,
    BorderShapeId.StraightEdgeSoftened,
    BorderShapeId.RoundedQuarterCircle,
    BorderShapeId.RoundedHalfCircle,
    BorderShapeId.AirplaneWings,
];

export const getLegsWithExceptions = (
    initialLegs: LegsShapeId[],
    exceptedLegs: LegsShapeId[],
): LegsShapeId[] => (
    initialLegs.filter((initialLeg) => !exceptedLegs.includes(initialLeg))
);

export const getBordersWithExceptions = (
    initialBorders: BorderShapeId[],
    exceptedBorders: BorderShapeId[],
): BorderShapeId[] => (
    initialBorders.filter((initialBorder) => !exceptedBorders.includes(initialBorder))
);

export default allLegs;
